export { default } from './Slider';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/Slider/index.js
// module id = 556
// module chunks = 2